var plugin_rtlignore_default = {
  "alignLeft": "os8bh",
  "textWrapNowrap": "B2y5v",
  "alignRight": "_5KWHS",
  "alignCenter": "Sn5nm",
  "sizeFullWidth": "TMk9h",
  "renderedInTable": "itGyN",
  "sizeOriginal": "UhBdh",
  "sizeContent": "Tbx9X",
  "sizeSmall": "KWKJ2",
  "sizeSmallCenter": "FXC9r",
  "flex": "RTIoZ",
  "atomic": "_6Vbxv",
  "anchor": "V0lcH",
  "embed": "_1WD2f",
  "horizontalScrollbar": "bRGLu",
  "pluginContainerMobile": "sl6z5"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
